<template>
    <va-button @click="showModal = true" :class="computedClass" :color="color">{{ buttonLabel }}</va-button>
    <va-modal
        v-model="showModal"
        :message="message"
        :title="buttonLabel + '?'"
        @ok="emitOk"
        @cancel="emitCancel"
    />
</template>

<script>
export default {
    name: 'AppConfirm',
    props: {
        color: {
            type: String,
            default: 'danger'
        },
        buttonLabel: String,
        message: String,
        class: String,
    },
    emits: ['ok', 'cancel'],
    computed: {
        computedClass() {
            return this.class
        }
    },
    data() {
        return {
            showModal: false
        }
    },
    methods: {
        emitOk() {
            this.showModal = false
            this.$emit("ok")
        },
        emitCancel() {
            this.showModal = false
            this.$emit("cancel")
        }
    }
}
</script>

<style scoped lang="scss">
</style>
